module.exports = __webpack_public_path__ + "static/media/share_link.693d2212.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/share_link.mp4
// module id = 241
// module chunks = 0